import React from 'react';
import styled from 'styled-components';
import { LFC } from '../../Legacy';
import { useResolve } from '../Container';
import { AccountModel } from '../account/AccountModel';
import { Copy, Flexer, FlexerProps, Title } from '../dashboard/elements/LayoutElements';
import { Colors } from './../../ui';

const enable = {};
const disable = {
    opacity: .6,
    pointerEvents: 'none',
    userSelect: 'none',
    filter: 'grayscale(.6)',
};

export const FeatureCallout = styled(Flexer)`
    position: relative;
    padding: 1.5rem 2.5rem 1.5rem 1.5rem; 
    font-weight: 450;
    font-size: 1.125rem;
    border-radius: .5rem; 

    background: ${Colors.positive};    
    ${Title}, ${Copy}, a {
        color: white;    
    }

    ${Copy} {
        margin-bottom: 1rem;
    }
`;

export const useFeatureCheck = (name: string) => {
    const { plan } = useResolve(AccountModel);
    return !!plan.features[name];
};

export const ShowIfHasFeature: LFC<{ name: string }> = ({ name, children }) => {
    const has = useFeatureCheck(name);
    return <>{has && children}</>;
};

export const HideIfHasFeature: LFC<{ name: string }> = ({ name, children }) => {
    const has = useFeatureCheck(name);
    return <>{!has && children}</>;
};

export const EnableIfHasFeature: LFC<FlexerProps & { name: string }> = ({ name, children, ...flexer }) => {
    const has = useFeatureCheck(name);
    const styling = has ? enable : disable;
    return <Flexer {...flexer} style={styling}>
        {children}
    </Flexer>;
};

export const DisableIfHasFeature: LFC<FlexerProps & { name: string }> = ({ name, children, ...flexer }) => {
    const has = useFeatureCheck(name);
    const styling = has ? disable : enable;
    return <Flexer {...flexer} style={styling}>
        {children}
    </Flexer>;
};

export const EnableIf: LFC<FlexerProps & { cond: boolean }> = ({ cond, children, ...flexer }) => {
    const styling = cond ? enable : disable;
    return <Flexer {...flexer} style={styling}>
        {children}
    </Flexer>;
};
